function initCollectionsBlockTabSwipers() {
  if (!('Swiper' in window)) {
    return;
  }
  document.querySelectorAll('.collections-block__tabs .swiper:not(.swiper--initialized)').forEach((swiperElement) => {
    swiperElement.classList.add('swiper--initialized');
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 400,
      mousewheel: {
        forceToAxis: true
      },
      on: {
        scrollbarDragEnd: function(swiper, event) {
          document.body.classList.remove('body--grabbing');
        },
        scrollbarDragStart: function(swiper, event) {
          document.body.classList.add('body--grabbing');
        },
        touchEnd: function(swiper, event) {
          document.body.classList.remove('body--grabbing');
        },
        touchStart: function(swiper, event) {
          if (swiper.slides.length <= swiper.slidesPerViewDynamic()) {
            return;
          }
          document.body.classList.add('body--grabbing');
        }
      }
    });
  });
}


function initCollectionsBlockTabButtons() {
  document.querySelectorAll('.collections-block--tabs').forEach((collectionsBlock) => {
    const tabButtons = collectionsBlock.querySelectorAll('.collections-block__tab-button');
    const tabContents = collectionsBlock.querySelectorAll('.collections-block__tab-content');
    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', () => {
        if (tabButton.classList.contains('collections-block__tab-button--active')) {
          return;
        }
        tabButtons.forEach((otherTabButton) => {
          if (otherTabButton.dataset.collectionId === tabButton.dataset.collectionId) {
            otherTabButton.classList.add('collections-block__tab-button--active');
          } else {
            otherTabButton.classList.remove('collections-block__tab-button--active');
          }
        });
        tabContents.forEach((tabContent) => {
          if (tabContent.dataset.collectionId === tabButton.dataset.collectionId) {
            tabContent.classList.add('collections-block__tab-content--active');
          } else {
            tabContent.classList.remove('collections-block__tab-content--active');
          }
        });
      });
    });
  });
}





function initCollectionsBlocks() {
  initCollectionsBlockTabSwipers();
  initCollectionsBlockTabButtons();
}


window.addEventListener('load', (event) => {
  initCollectionsBlockTabSwipers();
});


if (document.readyState !== 'loading') {
  initCollectionsBlocks();
} else {
  window.addEventListener('DOMContentLoaded', initCollectionsBlocks);
}
